import {
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_UNAUTHORIZED,
  AUTH_LOGOUT,
  AUTH_START_LOGIN_REQUEST,
  // MIDDLEWARE
  AUTH_LOGOUT_MIDDLEWARE,
  AUTH_FINISH,
} from '../constants/AUTH_CONSTANTS'

export const auth_login_success_action = (data) => {
  return {
    type: AUTH_LOGIN_SUCCESS,
    data: data,
  }
}
export const auth_login_unauthorized_action = () => {
  return {
    type: AUTH_LOGIN_UNAUTHORIZED,
  }
}

export const auth_start_login_request_action = () => {
  return {
    type: AUTH_START_LOGIN_REQUEST,
  }
}
export const auth_logout_action = () => ({
  type: AUTH_LOGOUT,
})
export const auth_finish_action = () => {
  return { type: AUTH_FINISH }
}

// MIDDLEWARE

export const auth_logout_middleware = () => {
  return {
    type: AUTH_LOGOUT_MIDDLEWARE,
  }
}
